var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetirement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_975_49193)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_49193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_975_49193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 34.6719H41.2976",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2187 34.6719V37.5052M18.1855 34.6719V37.5052",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 19.0898L20.905 30.4232H39.9381",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1342 21.1127C40.1451 21.4671 40.1333 21.8191 40.0993 22.1672L31.2456 18.5101L22.5126 14.9028C22.7206 14.6555 22.9445 14.4186 23.1837 14.1936C24.0423 13.3858 25.0829 12.7444 26.253 12.3157C27.4234 11.8868 28.697 11.6807 30.001 11.7172C31.3051 11.7538 32.6069 12.0321 33.8293 12.537C35.0517 13.042 36.1638 13.7606 37.1033 14.646C38.0427 15.5311 38.7875 16.5618 39.3039 17.6725C39.82 18.7827 40.0985 19.9517 40.1342 21.1127ZM39.9161 24.6813C40.9243 25.0978 42.084 24.6301 42.3055 23.5636C42.4738 22.7532 42.5464 21.9207 42.5206 21.0808C42.4745 19.5792 42.1146 18.0834 41.4617 16.679C40.8087 15.2745 39.8754 13.9889 38.7151 12.8955C37.5547 11.8021 36.19 10.9223 34.6989 10.3064C33.2078 9.69049 31.6195 9.3505 30.0246 9.30584C28.4298 9.26118 26.8596 9.51273 25.4038 10.0461C23.9481 10.5795 22.6351 11.3843 21.54 12.4146C20.9462 12.9732 20.4228 13.5922 19.9775 14.2603C19.3597 15.1871 19.8751 16.4032 20.9137 16.8322L29.2499 20.2756L23.1744 37.1581C22.95 37.7817 23.2736 38.4691 23.8972 38.6935C24.5208 38.9179 25.2082 38.5943 25.4327 37.9707L31.4705 21.1928L39.9161 24.6813Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_975_49193",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_975_49193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_975_49193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_975_49193",
    x: -12,
    y: -9,
    width: 80.6279,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_975_49193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_975_49193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_49193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetirement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/retirement.b4eb48c3f6002cd555beaf1bea93c18d.svg";